import {
    GET_DASHBOARD_OVERVIEW_START,
    GET_DASHBOARD_OVERVIEW_COMPLETE,
    GET_DASHBOARD_OVERVIEW_ERROR,
    GET_DASHBOARD_MISSED_SHIFT_DATA_START,
    GET_DASHBOARD_MISSED_SHIFT_DATA_COMPLETE,
    GET_DASHBOARD_MISSED_SHIFT_DATA_ERROR,
    GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_START,
    GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_COMPLETE,
    GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_ERROR,
    GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_START,
    GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_COMPLETE,
    GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_ERROR,
    UPDATE_ACTIVE_MENU_CLICK,
    GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_START,
    GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_COMPLETE,
    GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_ERROR,
    GET_DASHBOARD_TRAINING_GRAPH_DATA_START,
    GET_DASHBOARD_TRAINING_GRAPH_DATA_COMPLETE,
    GET_DASHBOARD_TRAINING_GRAPH_DATA_ERROR,
    GET_DASHBOARD_AVG_TENURE_DATA_START,
    GET_DASHBOARD_AVG_TENURE_DATA_COMPLETE,
    GET_DASHBOARD_AVG_TENURE_DATA_ERROR,
    UPDATE_ACTIVE_PAGE_TITLE,
    GET_DASHBOARD_GRAPH_OPTIONS_START,
    GET_DASHBOARD_GRAPH_OPTIONS_COMPLETE,
    GET_DASHBOARD_GRAPH_OPTIONS_ERROR,
    GET_CAREGIVER_INCENTIVE_UTILIZATION_START,
    GET_CAREGIVER_INCENTIVE_UTILIZATION_COMPLETE,
    GET_CAREGIVER_INCENTIVE_UTILIZATION_ERROR,
    GET_TOP_FOUR_REWARDS_START,
    GET_TOP_FOUR_REWARDS_COMPLETE,
    GET_TOP_FOUR_REWARDS_ERROR,
    GET_CAREGIVER_INCENTIVES_BRANCH_LIST_START,
    GET_CAREGIVER_INCENTIVES_BRANCH_LIST_COMPLETE,
    GET_CAREGIVER_INCENTIVES_BRANCH_LIST_ERROR,
    FETCH_AGENCIES_REQUEST_START,
    FETCH_AGENCIES_REQUEST_COMPLETE,
    FETCH_AGENCIES_REQUEST_ERROR,
    SET_SELECTED_AGENCY,
    GET_SEND_CARE_COINS_ENABLED_COMPLETE,
    GET_BALANCE_STATUS_START,
    GET_BALANCE_STATUS_COMPLETE,
    GET_BALANCE_STATUS_ERROR,
    SET_BALANCE_STATUS_API_CALL_COMPLETE,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
    dashboardOverviewError: undefined,
    dashboardMissedShiftError: undefined,
    dashboardTotalValueError: undefined,
    dashboardLiveDailyTrackerError: undefined,
    dashboardOverviewData: undefined,
    dashboardMissedShiftData: undefined,
    branchList: undefined,
    isDashboardGraphOPtionsStarted: false,
    dashboardGraphOptions: undefined,
    loading: false,
    agencies: [],
    selectedAgency: null,
    isSendCareCoinsEnabled: false,
    isFetchBalanceStatusCompleted: false,
};

const reducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case GET_DASHBOARD_OVERVIEW_START:
            return {
                ...state,
                isDashboardOverviewStarted: true,
                dashboardOverviewError: undefined,
                dashboardOverviewData: undefined,
                dashboardMissedShiftError: undefined,
                dashboardTotalValueError: undefined,
                isDashboardMissedShiftStarted: false,
                isDashboardToatalValueFeatchStarted: false,
            };
        case GET_DASHBOARD_OVERVIEW_COMPLETE:
            return {
                ...state,
                dashboardOverviewData: payload.data,
                isDashboardOverviewStarted: false,
                dashboardOverviewError: undefined,
            };
        case GET_DASHBOARD_OVERVIEW_ERROR:
            return {
                ...state,
                dashboardOverviewError: payload.error,
                isDashboardOverviewStarted: false,
                dashboardOverviewData: undefined,
            };
        case GET_DASHBOARD_MISSED_SHIFT_DATA_START:
            return {
                ...state,
                isDashboardMissedShiftStarted: true,
                dashboardMissedShiftError: undefined,
                dashboardMissedShiftData: undefined,
                dashboardTotalValueError: undefined,
                missedShiftIndicator: undefined
            };
        case GET_DASHBOARD_MISSED_SHIFT_DATA_COMPLETE:
            return {
                ...state,
                dashboardMissedShiftData: payload.data,
                isDashboardMissedShiftStarted: false,
                dashboardMissedShiftError: undefined,
                missedShiftIndicator: payload.missedShiftIndicator
            };
        case GET_DASHBOARD_MISSED_SHIFT_DATA_ERROR:
            return {
                ...state,
                dashboardMissedShiftError: payload.error,
                isDashboardMissedShiftStarted: false,
                dashboardMissedShiftData: undefined,
                missedShiftIndicator: undefined
            };
        case GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_START:
            return {
                ...state,
                isDashboardToatalValueFeatchStarted: true,
                dashboardTotalValueError: undefined,
                dashboardTotalValueData: undefined,
                branchList: undefined,
            };
        case GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_COMPLETE:
            return {
                ...state,
                dashboardTotalValueData: payload.data,
                branchList: payload.branchName,
                leftLegend: payload.left_legend,
                rightLegend: payload.right_legend,
                isDashboardToatalValueFeatchStarted: false,
                dashboardTotalValueError: undefined,
            };
        case GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_ERROR:
            return {
                ...state,
                dashboardTotalValueError: payload.error,
                isDashboardToatalValueFeatchStarted: false,
                dashboardTotalValueData: undefined,
                branchList: undefined,
            };
        case GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_START:
            return {
                ...state,
                isDashboardLiveDailyTrackerStarted: true,
                dashboardLiveDailyTrackerError: undefined,
                dashboardLiveDailyTrackerData: undefined,
            };
        case GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_COMPLETE:
            return {
                ...state,
                dashboardLiveDailyTrackerData: payload.data,
                isDashboardLiveDailyTrackerStarted: false,
                dashboardLiveDailyTrackerError: undefined,
            };
        case GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_ERROR:
            return {
                ...state,
                dashboardLiveDailyTrackerError: payload.error,
                isDashboardLiveDailyTrackerStarted: false,
                dashboardLiveDailyTrackerData: undefined,
            };
        case GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_START:
            return {
                ...state,
                isDashboardProductivtyScoreStarted: true,
                dashboardProductivityScoreError: undefined,
                dashboardProductivityScoreData: undefined,
                productivityScoreIndicator: undefined,
            };
        case GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_COMPLETE:
            return {
                ...state,
                dashboardProductivityScoreData: payload.data,
                isDashboardProductivtyScoreStarted: false,
                dashboardProductivityScoreError: undefined,
                productivityScoreIndicator: payload.productivityScoreIndicator,
            };
        case GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_ERROR:
            return {
                ...state,
                dashboardProductivityScoreError: payload.error,
                isDashboardProductivtyScoreStarted: false,
                dashboardProductivityScoreData: undefined,
                productivityScoreIndicator: undefined,
            };
        case GET_DASHBOARD_TRAINING_GRAPH_DATA_START:
            return {
                ...state,
                isDashboardTraningGraphStarted: true,
                dashboardTraningGraphError: undefined,
                dashboardTrainigGraphData: undefined,
                traningGraphIndicator: undefined,
            };
        case GET_DASHBOARD_TRAINING_GRAPH_DATA_COMPLETE:
            return {
                ...state,
                dashboardTrainigGraphData: payload.data,
                isDashboardTraningGraphStarted: false,
                dashboardTraningGraphError: undefined,
                traningGraphIndicator: payload.traningGraphIndicator,
            };
        case GET_DASHBOARD_TRAINING_GRAPH_DATA_ERROR:
            return {
                ...state,
                dashboardTraningGraphError: payload.error,
                isDashboardTraningGraphStarted: false,
                dashboardTrainigGraphData: undefined,
                traningGraphIndicator: undefined,
            };
        case GET_DASHBOARD_AVG_TENURE_DATA_START:
            return {
                ...state,
                isDashboardAvgTenureStarted: true,
                dashboardAvgTenureError: undefined,
                dashboardAvgTenureData: undefined,
                avgTenureIndicator: undefined,
            };
        case GET_DASHBOARD_AVG_TENURE_DATA_COMPLETE:
            return {
                ...state,
                dashboardAvgTenureData: payload.data,
                isDashboardAvgTenureStarted: false,
                dashboardAvgTenureError: undefined,
                avgTenureIndicator: payload.avgTenureIndicator,
            };
        case GET_DASHBOARD_AVG_TENURE_DATA_ERROR:
            return {
                ...state,
                dashboardAvgTenureError: payload.error,
                isDashboardAvgTenureStarted: false,
                dashboardAvgTenureData: undefined,
                avgTenureIndicator: undefined,
            };
        case GET_DASHBOARD_GRAPH_OPTIONS_START:
            return {
                ...state,
                isDashboardGraphOPtionsStarted: true,
                dashboardGraphOptions: undefined,
            };
        case GET_DASHBOARD_GRAPH_OPTIONS_COMPLETE:
            return {
                ...state,
                dashboardGraphOptions: payload.data,
                isDashboardGraphOPtionsStarted: false,
            };
        case GET_DASHBOARD_GRAPH_OPTIONS_ERROR:
            return {
                ...state,
                isDashboardGraphOPtionsStarted: false,
                dashboardGraphOptions: undefined,
            };
        case GET_CAREGIVER_INCENTIVE_UTILIZATION_START:
            return {
                ...state,
                isCaregiverIncentiveUtilizationStarted: true,
                caregiverIncentiveData: undefined,
            };
        case GET_CAREGIVER_INCENTIVE_UTILIZATION_COMPLETE:
            return {
                ...state,
                caregiverIncentiveData: payload.data,
                caregiverIncentiveLegend: payload.legend,
                isCaregiverIncentiveUtilizationStarted: false,
            };
        case GET_CAREGIVER_INCENTIVE_UTILIZATION_ERROR:
            return {
                ...state,
                isCaregiverIncentiveUtilizationStarted: false,
                caregiverIncentiveData: undefined,
            };
        case GET_TOP_FOUR_REWARDS_START:
            return {
                ...state,
                isTopRewardsFetchStarted: true,
                topFourRewardsData: undefined,
            };
        case GET_TOP_FOUR_REWARDS_COMPLETE:
            return {
                ...state,
                topFourRewardsData: payload.data,
                isTopRewardsFetchStarted: false,
            };
        case GET_TOP_FOUR_REWARDS_ERROR:
            return {
                ...state,
                isTopRewardsFetchStarted: false,
                topFourRewardsData: undefined,
            };
        case GET_CAREGIVER_INCENTIVES_BRANCH_LIST_START:
            return {
                ...state,
                isGetCaregiverIncentiveBranchStarted: true,
                caregiverIncentivesBranchList: undefined,
            };
        case GET_CAREGIVER_INCENTIVES_BRANCH_LIST_COMPLETE:
            return {
                ...state,
                caregiverIncentivesBranchList: payload.data,
                isGetCaregiverIncentiveBranchStarted: false,
            };
        case GET_CAREGIVER_INCENTIVES_BRANCH_LIST_ERROR:
            return {
                ...state,
                isGetCaregiverIncentiveBranchStarted: false,
                caregiverIncentivesBranchList: undefined,
            };
        case GET_BALANCE_STATUS_START:
            return {
                ...state,
                isGetBalanceStatusStarted: true,
                balanceStatusError: false,
                balanceStatusData: undefined,
            };
            case GET_BALANCE_STATUS_COMPLETE:
            return {
                ...state,
                balanceStatusData: payload.data,
                isGetBalanceStatusStarted: false,
                balanceStatusError: false,
            };
            case GET_BALANCE_STATUS_ERROR:
            return {
                ...state,
                isGetBalanceStatusStarted: false,
                balanceStatusData: undefined,
                balanceStatusError: true,
            };
            case SET_BALANCE_STATUS_API_CALL_COMPLETE:
            return {
                ...state,
                isFetchBalanceStatusCompleted: true,
                balanceStatusData: undefined,
            };
        case UPDATE_ACTIVE_MENU_CLICK:
            return {
                ...state,
                activeMenu: payload.activeMenu,
            };
        case UPDATE_ACTIVE_PAGE_TITLE:
            return {
                ...state,
                pageTitle: payload.pageTitle,
            };
        case FETCH_AGENCIES_REQUEST_START:
            return {
                ...state,
                error: null,
            };
        case FETCH_AGENCIES_REQUEST_COMPLETE:
            return {
                ...state,
                agencies: payload,

            };
        case FETCH_AGENCIES_REQUEST_ERROR:
            return {
                ...state,
                error: payload.error
            };
        case SET_SELECTED_AGENCY:
            return {
                ...state,
                selectedAgency: payload.value,
                // Availability is per agency -- clear it until the new agency's
                // answer arrives so the button cannot linger from the old one.
                isSendCareCoinsEnabled: false,
            };
        case GET_SEND_CARE_COINS_ENABLED_COMPLETE:
            return {
                ...state,
                isSendCareCoinsEnabled: payload,
            };
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
